import React from "react";
import { NavbarProps } from "./Navbar.types";
import { Button } from "../Button";

export const Navbar: React.FC<NavbarProps> = ({
  user,
  onLogout,
  onThemeToggle,
  onLanguageToggle,
}) => {
  return (
    <div
      style={{
        width: "100%",
        height: "50px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#5876EE",
        fontFamily: "Inter, sans-serif",
        padding: "0 16px",
        boxSizing: "border-box",
      }}
    >
      {/* LEFT SIDE — Logo + AIRCommand */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        {/* Public klasöründen çekilen logo */}
        <img
          src="/AIRCommand.svg"
          alt="Logo"
          style={{ width: 142.47, height: 16.5 }}
        />
        <span
          style={{
            fontSize: "17px",
            lineHeight: "20px",
            color: "#FFFFFF",
          }}
        >
          {/* (İstersen yazı da ekleyebilirsin buraya) */}
        </span>
      </div>

      {/* RIGHT SIDE — Menü */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <span
          style={{
            color: "#FFFFFF",
            fontSize: "14px",
            fontWeight: 400,
          }}
        >
          Welcome <strong>{user.name}</strong>{" "}
          <span style={{ opacity: 0.6 }}>({user.role})</span>
        </span>

        <button
          onClick={onThemeToggle}
          style={{
            width: "32px",
            height: "32px",
            border: "1px solid #FFFFFF",
            borderRadius: "4px",
            backgroundColor: "transparent",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 0,
          }}
        >
          <img
            src="public/light.svg"
            alt="theme"
            style={{ width: 18, height: 18 }}
          />
        </button>

        <button
          onClick={onLanguageToggle}
          style={{
            height: "32px",
            width: "32px", // Kompakt boyut için
            padding: "0",
            backgroundColor: "transparent",
            border: "1px solid #FFFFFF",
            borderRadius: "4px",
            color: "#FFFFFF",
            fontWeight: 500,
            cursor: "pointer",
            fontSize: "14px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          En
        </button>

        <button
          onClick={onLogout}
          style={{
            height: "32px",
            padding: "0 12px",
            backgroundColor: "transparent",
            border: "1px solid #FFFFFF",
            borderRadius: "4px",
            color: "#FFFFFF",
            fontWeight: 500,
            cursor: "pointer",
          }}
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default Navbar;
